import React, { useState, useEffect } from 'react';
import Popup from "../../../../Base/views/Popup";
import { Box, Chip } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux';
import { GetUpcomingHolidaysAction } from '../../../../../../store/Leave/HolidayCalendar/Action';
import MaterialTable, { MTableToolbar } from 'material-table';
import { ConvertDate } from "../../../../Base/helper/baseFunctions";
import { GetYearlyHolidayCalendarAction } from '../../../../../../store/Leave/YearlyHolidayCalendar/Action';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import { GetEmployeesAction } from "../../../../../../store/Employee/Employee/Action";
import { 
    GetOptionalHolidayCalendarAction,
    GetEmployeeOptionalHolidayCalendarAction,
    UpsertEmployeeOptionalHolidayCalendarAction,
    DeleteEmployeeOptionalHolidayCalendarAction
} from "../../../../../../store/Leave/OptionalHolidayCalendar/Action";

const ViewHolidayCalendar = ({
    openPopup,
    setOpenPopup,
    Holiday,
    optionalLeave = false
}) => {
    const dispatch = useDispatch();

    // Selectors for standard holiday list
    const { upcomingHolidaysData } = useSelector(state => state?.LeaveReducer.HolidayCalendarReducer);
    const { holidayData } = useSelector(state => state?.LeaveReducer?.YearlyHolidayCalendarReducer)

    // Selectors for optional leave allocation
    const { employees_options } = useSelector((state) => state.EmployeeReducer.EmployeesReducer)

    const { 
        optionalHolidayData, 
        isLoadingOptionalHoliday,
        employeeOptionalHolidayData,
        isLoadingEmployeeOptionalHoliday
    } = useSelector((state) => state.LeaveReducer?.OptionalHolidayCalendarReducer)

    // State for assignments
    const [assignments, setAssignments] = useState([]);
    const [employeesData, setEmployeesData] = useState({
        load: true,
        values: [],
      });
    const handleEmployees = () => {
            employees_options &&
                setEmployeesData({ load: false, values: employees_options });
    };
    useEffect(() => {
        if (optionalLeave) {
            dispatch(GetEmployeesAction({ is_active: true }));
            dispatch(GetOptionalHolidayCalendarAction({ year: new Date().getFullYear() }));
            dispatch(GetEmployeeOptionalHolidayCalendarAction({ year: new Date().getFullYear() }));
        } else if (Holiday) {
            dispatch(GetYearlyHolidayCalendarAction({ year: 0 }));
        } else {
            dispatch(GetUpcomingHolidaysAction());
        }
        //eslint-disable-next-line
    }, [optionalLeave, Holiday]);

    // Format the database rows into the table data structure
    const formatAssignments = (data) => {
        if (!data || data.length === 0) return [];
        
        // Group by employee_fk
        const groupedData = Object.values(
            data?.reduce((acc, item) => {

                const employeeId = item?.employee_id;
                if (!employeeId) return acc; // skip is employee_id is missing

                if (!acc[employeeId]) {
                acc[employeeId] = {
                    ...item,
                     employee_id: {
                        employee_id: item?.employee_id,
                        name: item?.employee_name,
                    },
                    optional_leaves: [],
                };
                }

                acc[employeeId].optional_leaves.push({
                    optional_holidaycalendar_pk:
                        item?.optional_holidaycalendar_pk,
                    name: item?.name,
                    date: item?.date,
                    description: item?.description,
                    employee_optional_holidaycalendar_mapping_pk: item?.employee_optional_holidaycalendar_mapping_pk
                });

                return acc;

            }, {})
            );
        return groupedData
    };

    // Load assignments from Redux state when data changes
    useEffect(() => {
        if (employeeOptionalHolidayData?.length) {
            setAssignments(formatAssignments(employeeOptionalHolidayData));
        }
        //eslint-disable-next-line
    }, [employeeOptionalHolidayData?.length]);
    const getPopupTitle = () => {
        if (optionalLeave) return "Team Optional Holiday Allocation";
        return Holiday ? "Holiday Calendar" : "Upcoming Holidays";
    };
    return (
        <>
            <Popup
                title={getPopupTitle()}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                fullWidth={true}
                maxWidth={optionalLeave ? "md" : "sm"}
            >
                <Box margin="0px">
                    {optionalLeave ? (
                        <MaterialTable
                            isLoading={isLoadingEmployeeOptionalHoliday}
                            columns={[
                               {
                                title: "Employee",
                                headerStyle: {
                                textAlign: "start",
                                paddingLeft: "2%",
                                },
                                cellStyle: {
                                textAlign: "start",
                                padding: "0px 0px 0px 2%",
                                },
                                field: "employee_id",
                                grouping: false,
                                validate: (rowData) => {
                                if (rowData.employee_id?.name) {
                                    return "";
                                } else {
                                    return "Employee cannot be empty";
                                }
                                },
                                render: (rowData) => rowData.employee_id?.name || "",
                                editComponent: (props) => {
                                const isEdit = props.rowData?.tableData?.editing === "update";
                                return (
                                    <Box sx={{ width: "100%", mb: -0.5 }}>
                                    <SelectableSearch
                                        fullWidth
                                        variantType="standard"
                                        size="small"
                                        disabled={isEdit}
                                        loading={() => handleEmployees()}
                                        placeholder="Select Employee"
                                        value={props.value}
                                        fieldLabel="name"
                                        name="employee_id"
                                        onChangeEvent={(e, v) => {
                                        props.onChange(v);
                                        }}
                                        data={employeesData}
                                    />
                                    </Box>
                                );
                                },
                                customFilterAndSearch: (search, rowData) =>
                                (rowData?.employee_id?.name || "")
                                    .toLowerCase()
                                    .includes(search.toLowerCase()),
                            },
                                {
                                    title: "Selected Optional Holidays",
                                    field: "optional_leaves",
                                    validate: (rowData) => (rowData.optional_leaves?.length > 0 ? "" : "Please select at least one optional holiday"),
                                    render: (rowData) => (
                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                            {rowData.optional_leaves?.map((item) => (
                                                <Chip
                                                    key={item.optional_holidaycalendar_pk}
                                                    label={item.name}
                                                    size="small"
                                                    variant="outlined"
                                                />
                                            ))}
                                        </Box>
                                    ),
                                    editComponent: (props) => {
                                        return (
                                            <Box sx={{ width: "100%", mb: -0.5 }}>
                                                <SelectableSearch
                                                    multiple={true}
                                                    fullWidth
                                                    variantType="standard"
                                                    size="small"
                                                    loading={() => {}}
                                                    placeholder="Select optional holidays"
                                                    value={props.value || []}
                                                    fieldLabel="name"
                                                    name="optional_leaves"
                                                    isOptionEqualToValue={(option, value) => option.optional_holidaycalendar_pk === value.optional_holidaycalendar_pk}
                                                    onChangeEvent={(name, value) => {
                                                        props.onChange(value || []);
                                                    }}
                                                    data={{
                                                        values: optionalHolidayData || [],
                                                        load: isLoadingOptionalHoliday
                                                    }}
                                                    required={true}
                                                />
                                            </Box>
                                        );
                                    }
                                }
                            ]}
                            data={assignments}
                            options={{
                                maxBodyHeight: 350,
                                rowStyle: { fontSize: "13px", height: "45px" },
                                headerStyle: { padding: "10px 15px", fontWeight: "bold" },
                                sorting: true,
                                search: true,
                                searchFieldAlignment: "right",
                                searchAutoFocus: false,
                                searchFieldVariant: "standard",
                                paging: true,
                                pageSize: 5,
                                pageSizeOptions: [5, 10, 20],
                                addRowPosition: "first",
                                selection: false,
                                actionsColumnIndex: -1
                            }}
                            icons={{
                                Add: () => <AddIcon sx={{ color: "#637381" }} />,
                                Edit: (props) => <EditIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }} />,
                                Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }} />
                            }}
                            editable={{
                                onRowAdd: (newRow) =>
                                    new Promise((resolve, reject) => {
                                        if (!newRow.employee_id || !newRow.optional_leaves || newRow.optional_leaves.length === 0) {
                                            return reject();
                                        }
                                        newRow.optional_leaves?.forEach((item, index) => {
                                            dispatch(UpsertEmployeeOptionalHolidayCalendarAction({
                                                employee_fk: newRow.employee_id?.employee_id,
                                                optional_holidaycalendar_pk: item?.optional_holidaycalendar_pk,
                                                reason_description: "",
                                                year: new Date().getFullYear(),
                                                toast: index === 0,
                                            }));
                                        });
                                        setTimeout(() => {
                                            if (employeeOptionalHolidayData?.length) {
                                                setAssignments(formatAssignments(employeeOptionalHolidayData));
                                            }
                                            resolve();
                                        }, 1000);
                                    }),
                                onRowUpdate: (newRow, oldRow) =>
                                    new Promise((resolve, reject) => {
                                        if (!newRow.employee_id || !newRow.optional_leaves || newRow.optional_leaves.length === 0) {
                                            return reject();
                                        }
                                        const oldLeaves = oldRow.optional_leaves || [];
                                        const newLeaves = newRow.optional_leaves || [];
                                        // 1. Identify deleted mappings
                                        const deleted = oldLeaves.filter(oldItem => 
                                            !newLeaves.some(newItem => newItem.optional_holidaycalendar_pk === oldItem.optional_holidaycalendar_pk)
                                        );
                                        // 2. Identify added mappings
                                        const added = newLeaves.filter(newItem => 
                                            !oldLeaves.some(oldItem => oldItem.optional_holidaycalendar_pk === newItem.optional_holidaycalendar_pk)
                                        );
                                        
                                        // Dispatch adds
                                        if (added?.length > 0) {
                                            added?.forEach((item,index) => {
                                                dispatch(UpsertEmployeeOptionalHolidayCalendarAction({
                                                    employee_fk: newRow.employee_id?.employee_id,
                                                    optional_holidaycalendar_pk: item.optional_holidaycalendar_pk,
                                                    reason_description: "",
                                                    year: new Date().getFullYear(),
                                                    toast: index === 0,
                                                },
                                                (result,error) => {
                                                if (!error && result?.data?.statuscode === 200) {
                                                    if (deleted.length > 0) {
                                                        const idsString = `{${deleted.map(item => item?.employee_optional_holidaycalendar_mapping_pk).join(',')}}`;
                                                        dispatch(DeleteEmployeeOptionalHolidayCalendarAction({
                                                            year: new Date().getFullYear(),
                                                            employee_optional_holidaycalendar_ids: idsString,
                                                            toast: "updating"
                                                        }));
                                                    }
                                                } 
                                                }
                                            ));
                                            });
                                        } else {
                                            if (deleted.length > 0) {
                                                const idsString = `{${deleted.map(item => item?.employee_optional_holidaycalendar_mapping_pk).join(',')}}`;
                                                dispatch(DeleteEmployeeOptionalHolidayCalendarAction({
                                                    year: new Date().getFullYear(),
                                                    employee_optional_holidaycalendar_ids: idsString,
                                                    toast: "updating"
                                                }));
                                            }
                                        }
                                        setTimeout(() => {
                                            resolve();
                                        }, 2000);
                                    }),
                                onRowDelete: (selectedRow) =>
                                    new Promise((resolve) => {
                                        const selectedLeaves = selectedRow?.optional_leaves || [];
                                        if (selectedLeaves.length > 0) {
                                            const idsString = `{${selectedLeaves.map(item => item.employee_optional_holidaycalendar_mapping_pk).join(',')}}`;
                                            dispatch(DeleteEmployeeOptionalHolidayCalendarAction({
                                                year: new Date().getFullYear(),
                                                employee_optional_holidaycalendar_ids: idsString
                                            }));
                                        }
                                        setTimeout(() => {
                                            resolve();
                                        }, 1000);
                                    })
                            }}
                            title=""
                            components={{
                                Toolbar: (props) => (
                                    <Box sx={{ minHeight: "5px" }}>
                                        <MTableToolbar {...props} />
                                    </Box>
                                )
                            }}
                        />
                    ) : (
                        <MaterialTable
                            columns={[
                                {
                                    title: "Date", field: "date", cellStyle: { padding: "10px" },
                                    render: rowData => {
                                        return rowData?.date ? ConvertDate(rowData.date) : ""
                                    }
                                },
                                { title: "Name", field: "name", cellStyle: { padding: "10px" }, },
                            ]}
                            data={Holiday ? holidayData : upcomingHolidaysData}
                            options={{
                                maxBodyHeight: 265,
                                rowStyle: { fontSize: "13px", border: "1px" },
                                headerStyle: { padding: "0px 10px", fontWeight: "bold" },
                                sorting: true,
                                search: true,
                                searchFieldAlignment: "right",
                                searchAutoFocus: true,
                                searchFieldVariant: "standard",
                                paging: true,
                                pageSize: 10,
                                pageSizeOptions: [10, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                paginationPosition: "bottom",
                            }}
                            title=""
                            components={{
                                Toolbar: (props) => (
                                    <Box sx={{ minHeight: "5px" }}>
                                        <MTableToolbar {...props} />
                                    </Box>
                                ),
                            }}
                        />
                    )}
                </Box>
            </Popup>
        </>
    )
}

export default ViewHolidayCalendar;